import ProductCard from 'components/product/ProductCard'
import ProductModal from 'components/product/ProductCard/ProductModal'
import useCart from 'hooks/useCart'
import { isAbsent, isPresent } from 'lib/utils'
import { useCallback, useState } from 'react'
import { IProduct, type IGetSpecialsResult } from 'store/api'

type Props = {
  products: IGetSpecialsResult['sub'][number]['products']
}

const SuggestedProducts = ({ products }: Props) => {
  const onOrderButtonClick = useCallback((product: IProduct) => {
    setProduct(product)
    setIsProductModalOpen(true)
  }, [])

  const closeProductModal = useCallback(() => {
    setProduct(null)
    setIsProductModalOpen(false)
  }, [])

  let [product, setProduct] = useState<IProduct | null>(null)
  let [isProductModalOpen, setIsProductModalOpen] = useState(false)

  const { items } = useCart()

  const renderItem = useCallback(
    (p: any) => {
      const _item = items.find((i) => i.product.id === p.id)
      const isSimpleProduct =
        (p.type === 'simple' || p.variations_count == 1) &&
        isAbsent(p.options?.ingsgroups)

      const quantity = isPresent(_item)
        ? isSimpleProduct
          ? _item.quantity
          : items.reduce((count, i) => {
              if (i.product.id === p.id) count += i.quantity
              return count
            }, 0)
        : 0
      return (
        <ProductCard
          {...p}
          key={p.id}
          descClassName='font-light'
          cb={() => onOrderButtonClick(p)}
          items={items}
          quantity={quantity}
        />
      )
    },
    [onOrderButtonClick, items]
  )

  return (
    <>
      <div className='pb-4 px-0 grid gap-1 lg:gap-2 grid-cols-2 md:grid-cols-4 xl:grid-cols-5'>
        {products.map((x) => renderItem(x))}
      </div>

      <ProductModal
        isProductModalOpen={isProductModalOpen}
        closeProductModal={closeProductModal}
        product={product}
      />
    </>
  )
}

export default SuggestedProducts
